import {ReactNode} from 'react';
import {ErpRouterContext, ErpRouterContextModel} from './erp-react-router-context';

interface Props extends ErpRouterContextModel {
  children: ReactNode;
}

export function ErpReactRouterWrapper(props: Props) {
  return <ErpRouterContext.Provider value={{routeAngular: props.routeAngular}}>
    {props.children}
  </ErpRouterContext.Provider>;
}
